module.exports = __webpack_public_path__ + "img/android.b10888a9.svg";